import gql from 'graphql-tag';

export const CCA_TRIGGER_NOW_MUTATION = gql`
  mutation CcaTriggerNowMutation($articleIds: [ID!]!) {
    ccaTriggerNow(articleIds: $articleIds) {
      jobIds
    }
  }
`;
